module.exports = __webpack_public_path__ + "media/water_zd.d0a49b66.mp4";